import { render, staticRenderFns } from "./CardTypePage.vue?vue&type=template&id=517188f5&"
import script from "./CardTypePage.vue?vue&type=script&lang=js&"
export * from "./CardTypePage.vue?vue&type=script&lang=js&"
import style0 from "./CardTypePage.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports